import { useCallback } from 'react';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PPA_WHITESPACE_TOGGLE_CHANGED } from 'utils/mixpanelEventNames';
import type { computeWhitespaceGridMetrics } from './whitespaceMixpanel.helpers';

type GridMetrics = ReturnType<typeof computeWhitespaceGridMetrics>;

type UseWhitespaceShowWhitespacesParams = {
    showWhitespaces: boolean;
    setShowWhitespaces: (value: boolean) => void;
    baseProps: Record<string, unknown>;
    gridMetrics: GridMetrics;
};

const useWhitespaceShowWhitespaces = ({
    showWhitespaces,
    setShowWhitespaces,
    baseProps,
    gridMetrics,
}: UseWhitespaceShowWhitespacesParams) => {
    const handleShowWhitespacesChange = useCallback(
        (checked: boolean) => {
            trackEventMixpanel(PPA_WHITESPACE_TOGGLE_CHANGED, {
                previous_state: showWhitespaces,
                new_state: checked,
                opportunity_cell_count: gridMetrics.opportunity_cell_count,
                visible_cell_count: gridMetrics.visible_cell_count,
                ...baseProps,
            });
            setShowWhitespaces(checked);
        },
        [baseProps, gridMetrics.opportunity_cell_count, gridMetrics.visible_cell_count, setShowWhitespaces, showWhitespaces],
    );

    return { handleShowWhitespacesChange };
};

export default useWhitespaceShowWhitespaces;
